<template>
  <div class="device-type-rule-bd tb">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" @click="addRule()" v-if="funcView.device_change_rule_add">{{ funcView.device_change_rule_add }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 产品型号 -->
        <el-form-item style="float: right">
          <custom-select
            :filterable="true"
            v-model="formSearch.productCode"
            url="productCodeSelectList"
            :props="{ label: 'productName', value: 'productCode' }"
            :placeholder="$t('crm_deviceChangeRule.chan_pin_xing_hao')"
            width="160px"
            @change="onPageChange({ page: 1 })"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table :data="tableList" :column="tableColumn" @filter="filterChange" @sort="sortChange" height="100%" :slots="['productCodeAndSn', 'toProductCodeAndSn', 'action']">
        <template v-slot:productCodeAndSn="scope">
          <span>{{ scope.row.productCode }}</span>
          <span v-if="scope.row.productSns">/{{ scope.row.productSns }}</span>
        </template>
        <template v-slot:toProductCodeAndSn="scope">
          <span>{{ scope.row.toProductCode }}</span>
          <span v-if="scope.row.toProductSns">/{{ scope.row.toProductSns }}</span>
        </template>
        <template slot="action" slot-scope="scope">
          <span></span>
          <el-button v-if="funcView.device_change_rule_edit" type="text" size="mini" @click="editRule(scope.row)">{{ funcView.device_change_rule_edit }}</el-button>
          <el-button v-if="funcView.device_change_rule_delete" type="text" size="mini" @click="delRule(scope.row)">{{ funcView.device_change_rule_delete }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis.js';

export default {
  name: 'deviceChangeRule',
  data() {
    return {
      tableCode: 'deviceChangeRule',
      tableList: [],
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        productCode: '',
        pageSize: 50,
        pageNum: 1,
      },
      totalRows: null,
    };
  },
  methods: {
    getTableList() {
      this.$getJSON(apis.deviceChangeRulePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    addRule() {
      this.clearTagByKeep('device_change_rule_item');
      this.jump('/redirect/offer/deviceChangeRule/add', {
        type: 'add',
        parentPath: '/offer/deviceChangeRule',
      });
    },
    editRule(row) {
      this.clearTagByKeep('device_change_rule_item');
      this.jump('/redirect/offer/deviceChangeRule/edit', {
        type: 'edit',
        parentPath: '/offer/deviceChangeRule',
        productCode: row.productCode,
        productSns: row.productSns
      });
    },
    delRule(row) {
      this.$showConfirm(this.$t('crm_deviceChangeRule.nqdyscgsbghgzm')).then(() => {
        this.$postJSON(`${apis.deviceChangeRuleDelete}/${row.ruleId}`).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success'),
          });
          this.getTableList();
        });
      });
    },
  },
  mounted() {
    this.getTableColumn();
    this.getFuncView();

    this.getTableList();
  },
};
</script>

<style></style>
